"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.queueEvents = exports.QueueMeetingEvent = void 0;
var QueueMeetingEvent;
(function (QueueMeetingEvent) {
    QueueMeetingEvent["started"] = "created";
    QueueMeetingEvent["finished"] = "finished";
    QueueMeetingEvent["personJoined"] = "person-joined";
    QueueMeetingEvent["personLeft"] = "person-left";
    QueueMeetingEvent["updated"] = "updated";
    QueueMeetingEvent["recordingStarted"] = "recording-started";
    QueueMeetingEvent["recordingStopped"] = "recording-stopped";
    QueueMeetingEvent["languageUpdated"] = "language-updated";
    QueueMeetingEvent["transcriptionStarted"] = "transcription-started";
    QueueMeetingEvent["transcriptionFinished"] = "transcription-finished";
    QueueMeetingEvent["webhook"] = "webhook";
    QueueMeetingEvent["egressEvent"] = "egress";
    QueueMeetingEvent["updateMetadata"] = "update-metadata";
})(QueueMeetingEvent || (exports.QueueMeetingEvent = QueueMeetingEvent = {}));
exports.queueEvents = {
    started: (meetingId) => ({ type: QueueMeetingEvent.started, meetingId }),
    finished: (meetingId) => ({ type: QueueMeetingEvent.finished, meetingId }),
    personJoined: (meetingId, person, identity) => ({
        type: QueueMeetingEvent.personJoined,
        meetingId,
        person,
        identity
    }),
    personLeft: (meetingId, person, identity) => ({
        type: QueueMeetingEvent.personLeft,
        meetingId,
        person,
        identity
    }),
    updated: (meetingId) => ({ type: QueueMeetingEvent.updated, meetingId }),
    recordingStarted: (meetingId) => ({
        type: QueueMeetingEvent.recordingStarted,
        meetingId
    }),
    recordingStopped: (meetingId) => ({
        type: QueueMeetingEvent.recordingStopped,
        meetingId
    }),
    languageUpdated: (meetingId) => ({
        type: QueueMeetingEvent.languageUpdated,
        meetingId
    }),
    transcriptionStarted: (meetingId) => ({
        type: QueueMeetingEvent.transcriptionStarted,
        meetingId
    }),
    transcriptionFinished: (meetingId) => ({
        type: QueueMeetingEvent.transcriptionFinished,
        meetingId
    }),
    webhook: (meetingId, webhook) => ({
        type: QueueMeetingEvent.webhook,
        meetingId,
        webhook
    }),
    egressEvent: (meetingId, egressId, egressStatus, meta) => ({
        type: QueueMeetingEvent.egressEvent,
        meetingId,
        egressId,
        egressStatus,
        meta
    }),
    updateMetadata: (meetingId, roomName, metadata) => ({
        type: QueueMeetingEvent.updateMetadata,
        roomName,
        meetingId,
        metadata
    })
};
//# sourceMappingURL=queue.js.map